
import Header from "../common/header/DefaultHeader";
import MobileMenu from "../common/header/MobileMenu";
import PopupSignInUp from "../common/PopupSignInUp";
import ErrorPageContent from "./ErrorPageContent";
import Footer from "../common/footer/Footer";
import OtherLinkFooter from "../common/footer/OtherLinkFooter";
import NewFooter from "../common/footer/NewFooter";

const index = () => {
  return (
    <>
      {/* <!-- Main Header Nav --> */}
      <Header />

      {/* <!--  Mobile Menu --> */}
      <MobileMenu />

      {/* <!-- Modal --> */}
      <PopupSignInUp />

      {/* <!-- Our Error Page --> */}
      <section className="our-error">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <ErrorPageContent />
            </div>
          </div>
        </div>
         {/* <section className="footer_one home6 bg-ptrn2">
                <div className="container">
                  <div className="row">
                    <Footer />
                  </div>
                </div>
              </section> */}
                 <div className="container-fluid px-0">
                              {/* <Footer /> */}
                              <OtherLinkFooter/>
                              <NewFooter/>
                          </div>
        
      </section>

      
    </>
  );
};

export default index;
